import { awaitAllCallbacks, consumeCallback } from "../singletons/callbacks.js";

export { awaitAllCallbacks, consumeCallback };
